import React, { useEffect, useState } from 'react'
import baseURL from "../component/baseURL";
import showNotification from '../component/Notification';
import { useNavigate } from 'react-router-dom';
import stringsoflanguages from '../component/stringsoflanguages';

export default function FeedsRequested({ hideMobileHeader = false }) {
    const navigate = useNavigate();
    const [userID, setUserID] = useState(null);
    const [loading, setLoading] = useState(false);
    const [feedsRequested, setFeedsRequested] = useState([]);
    const [cancelModalRequestId, setCancelModalRequestId] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    useEffect(() => {
        const userid = localStorage.getItem('user_id');
        setUserID(userid);
        fetchFeedsRequested(userid);
    }, []);

    function fetchFeedsRequested(userid) {
        setLoading(true);
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/portfolio_feed/feed_request_sent', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response?.member_feed_active;
                if (responseJson.server?.code === 200 && Array.isArray(result)) {
                    setFeedsRequested(result);
                } else {
                    setFeedsRequested([]);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }


    function cancelFeedRequest(requestID) {
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        formdata.append("request_id", requestID)

        fetch(baseURL.URL + '/portfolio_feed/cancel_feed_request', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code === 200) {
                    setTimeout(() => { fetchFeedsRequested(userID) }, 50)
                    showNotification(responseJson.server.message, 'success', 'top-right')
                }
                else {
                    showNotification(responseJson.server.message, 'danger', 'top-right')
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function handleCancelClick(requestId) {
        if (requestId) setCancelModalRequestId(requestId);
    }

    function handleCancelConfirm() {
        if (cancelModalRequestId) {
            cancelFeedRequest(cancelModalRequestId);
        }
        setCancelModalRequestId(null);
    }

    function handleCancelClose() {
        setCancelModalRequestId(null);
    }

    if (loading) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className={`content-right ${isMobile ? 'feed-requested-page-mobile' : ''}`}>
            {isMobile && !hideMobileHeader && (
                <div className="mobile-page-header">
                    <button type="button" className="mobile-back-btn" onClick={() => navigate('/feed')} aria-label="Back">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <h2 className="mobile-page-title">{stringsoflanguages.feedsRequested}</h2>
                </div>
            )}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                    />
                </div>
                <button className="filter-btn">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.4062 4.69678C14.5256 4.69678 12.9441 6.04475 12.5793 7.82178H2.34375C1.91228 7.82178 1.5625 8.17156 1.5625 8.60303C1.5625 9.0345 1.91228 9.38428 2.34375 9.38428H12.5793C12.9441 11.1613 14.5256 12.5093 16.4062 12.5093C18.2869 12.5093 19.8684 11.1613 20.2332 9.38428H22.6562C23.0877 9.38428 23.4375 9.0345 23.4375 8.60303C23.4375 8.17156 23.0877 7.82178 22.6562 7.82178H20.2332C19.8684 6.04475 18.2869 4.69678 16.4062 4.69678ZM16.4062 6.25928C17.7099 6.25928 18.75 7.29938 18.75 8.60303C18.75 9.90668 17.7099 10.9468 16.4062 10.9468C15.1026 10.9468 14.0625 9.90668 14.0625 8.60303C14.0625 7.29938 15.1026 6.25928 16.4062 6.25928Z"
                            fill="white"
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.59375 12.5093C6.71313 12.5093 5.1316 13.8573 4.76685 15.6343H2.34375C1.91228 15.6343 1.5625 15.9841 1.5625 16.4155C1.5625 16.847 1.91228 17.1968 2.34375 17.1968H4.76685C5.1316 18.9738 6.71313 20.3218 8.59375 20.3218C10.4744 20.3218 12.0559 18.9738 12.4207 17.1968H22.6562C23.0877 17.1968 23.4375 16.847 23.4375 16.4155C23.4375 15.9841 23.0877 15.6343 22.6562 15.6343H12.4207C12.0559 13.8573 10.4744 12.5093 8.59375 12.5093ZM8.59375 14.0718C9.8974 14.0718 10.9375 15.1119 10.9375 16.4155C10.9375 17.7192 9.8974 18.7593 8.59375 18.7593C7.2901 18.7593 6.25 17.7192 6.25 16.4155C6.25 15.1119 7.2901 14.0718 8.59375 14.0718Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>

            <div className="feed-recived-section">
                <div className="feed-received-grid">
                    {feedsRequested.map((item, index) => {
                        const ud = item.user_details ?? {};
                        const name = (ud.user_name && String(ud.user_name).trim()) ? ud.user_name.trim() : ([ud.fname, ud.lname].filter(Boolean).join(' ') || '—');
                        const locationStr = [ud.city_name, ud.country_name].filter(Boolean).join(', ') || 'Null';
                        const avatar = ud.user_image_thumb ?? ud.user_image ?? '';
                        const companyImage = ud.company_image_thumb ?? ud.company_image ?? '';
                        const dateStr = (item.added_date ?? '').replace(/\//g, '-');
                        return (
                            <div key={item.request_id ?? index} className="feed-received-card">
                                <div className="feed-card-top">
                                    <div className="feed-card-profile">
                                        <img src={avatar || 'https://placehold.co/48x48'} alt={name} />
                                    </div>
                                    <div className="feed-card-info">
                                        <h3 className="feed-card-name">{name}</h3>
                                        <p className="feed-card-location">{locationStr}</p>
                                    </div>
                                    <div className="feed-card-placeholder">
                                        <img src={companyImage || 'https://placehold.co/48x48'} alt={name} />
                                    </div>
                                </div>
                                <div className="feed-card-bottom">
                                    <div className="feed-status">
                                        <div className="feed-download-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <g clipPath={`url(#clip0_feeds_req_${index})`}>
                                                    <path d="M14.4554 11.1097C14.2519 10.9062 13.9211 10.9062 13.7176 11.1097L12.5218 12.3055V1.04324C12.5218 0.75524 12.288 0.521484 12 0.521484C11.712 0.521484 11.4783 0.75524 11.4783 1.04324V13.565C11.4783 13.7757 11.6056 13.9667 11.8007 14.0471C11.8654 14.0742 11.9332 14.0867 12 14.0867C12.1357 14.0867 12.2692 14.0335 12.3684 13.9344L14.4554 11.8474C14.6588 11.644 14.6588 11.3132 14.4554 11.1097Z" fill="white" />
                                                    <path d="M12.3684 13.1971L10.2815 11.1101C10.078 10.9067 9.7472 10.9067 9.54372 11.1101C9.34024 11.3136 9.34024 11.6444 9.54372 11.8479L11.6307 13.9349C11.733 14.0361 11.8665 14.0872 12.0001 14.0872C12.1337 14.0872 12.2672 14.0361 12.3684 13.9349C12.5719 13.7313 12.5719 13.4006 12.3684 13.1971Z" fill="white" />
                                                    <path d="M23.3864 11.9657L19.6247 6.32255C18.9454 5.30413 17.809 4.6958 16.5861 4.6958H14.0869C13.7989 4.6958 13.5652 4.92956 13.5652 5.21756C13.5652 5.50556 13.7989 5.73931 14.0869 5.73931H16.5861C17.4594 5.73931 18.2713 6.17341 18.7565 6.9007L22.5182 12.5438C22.8052 12.9737 22.9565 13.4746 22.9565 13.9911V20.8697C22.9565 21.7327 22.2542 22.4349 21.3913 22.4349H2.60868C1.74571 22.4349 1.04346 21.7327 1.04346 20.8697V14.0683C1.04346 13.5101 1.21774 12.9768 1.56311 12.5041L4.93772 7.38274C5.616 6.35283 6.7565 5.73926 7.98779 5.73926H9.913C10.201 5.73926 10.4348 5.50551 10.4348 5.21751C10.4348 4.92951 10.2011 4.6958 9.91305 4.6958H7.98784C6.40384 4.6958 4.93777 5.4857 4.06643 6.80884L0.706451 11.9093C0.244174 12.5407 0 13.2867 0 14.0683V20.8697C0 22.3076 1.17078 23.4784 2.60868 23.4784H21.3913C22.8292 23.4784 24 22.3076 24 20.8697V13.9911C24 13.268 23.7882 12.5678 23.3864 11.9657Z" fill="white" />
                                                    <path d="M22.9565 13.0435H20.3478C18.9099 13.0435 17.7392 14.2142 17.7392 15.6521C17.7392 16.5151 17.0369 17.2174 16.1739 17.2174H7.8261C6.96313 17.2174 6.26089 16.5151 6.26089 15.6521C6.26089 14.2142 5.09011 13.0435 3.65221 13.0435H1.04348C0.755484 13.0435 0.521729 13.2772 0.521729 13.5652C0.521729 13.8532 0.755484 14.0869 1.04348 14.0869H3.65216C4.51513 14.0869 5.21738 14.7892 5.21738 15.6521C5.21738 17.09 6.38816 18.2608 7.82606 18.2608H16.1739C17.6118 18.2608 18.7826 17.09 18.7826 15.6521C18.7826 14.7892 19.4849 14.0869 20.3478 14.0869H22.9565C23.2445 14.0869 23.4783 13.8532 23.4783 13.5652C23.4783 13.2772 23.2445 13.0435 22.9565 13.0435Z" fill="white" />
                                                </g>
                                                <defs>
                                                    <clipPath id={`clip0_feeds_req_${index}`}>
                                                        <rect width="24" height="24" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <div className="feed-status-text">
                                            <span className="feed-status-label">{stringsoflanguages.feedRequested}</span>
                                            <span className="feed-status-date">{dateStr}</span>
                                        </div>
                                    </div>
                                    <div className="feed-card-actions">
                                        {/* <button type="button" className="feed-action-btn feed-accept-btn">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M10.9376 0C16.9772 0 21.8751 4.89798 21.8751 10.9376C21.8751 16.9772 16.9772 21.8751 10.9376 21.8751C4.89798 21.8751 0 16.9772 0 10.9376C0 4.89798 4.89798 0 10.9376 0ZM8.66624 14.4902L5.98846 11.8102C5.53226 11.3537 5.53216 10.6093 5.98846 10.1529C6.44485 9.69664 7.19254 9.6995 7.64561 10.1529L9.53343 12.0422L14.2297 7.34598C14.6861 6.88959 15.4305 6.88959 15.8868 7.34598C16.3432 7.80227 16.3426 8.54738 15.8868 9.00312L10.3607 14.5293C9.90493 14.985 9.15981 14.9857 8.70352 14.5293C8.6907 14.5165 8.67833 14.5035 8.66624 14.4902Z" fill="#00BA00" />
                                            </svg>
                                        </button> */}
                                        <button
                                            type="button"
                                            className="feed-action-btn feed-delete-btn"
                                            onClick={() => handleCancelClick(item.request_id)}
                                            aria-label="Cancel request"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M10.5325 2.0835C9.76543 2.0835 9.1436 2.70532 9.1436 3.47238C9.1436 3.85591 8.83269 4.16683 8.44915 4.16683H8.33342H5.20841C4.63312 4.16683 4.16675 4.6332 4.16675 5.2085C4.16675 5.78379 4.63312 6.25016 5.20841 6.25016H8.33342H8.44915H16.5494H16.551H16.6667H19.7917C20.3671 6.25016 20.8334 5.78379 20.8334 5.2085C20.8334 4.6332 20.3671 4.16683 19.7917 4.16683H16.5502C16.1671 4.16637 15.8565 3.85564 15.8565 3.47238C15.8565 2.70532 15.2348 2.0835 14.4677 2.0835H10.5325Z" fill="#ED6D48" />
                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.25016 8.3335C5.95886 8.3335 5.68087 8.45548 5.48362 8.66984C5.28638 8.8842 5.1879 9.17137 5.2121 9.46167L6.01497 19.0962C6.19493 21.2558 8.00021 22.9168 10.1672 22.9168H14.8331C17.0002 22.9168 18.8054 21.2558 18.9854 19.0962L19.7882 9.46167C19.8125 9.17137 19.7139 8.8842 19.5167 8.66984C19.3194 8.45548 19.0415 8.3335 18.7502 8.3335H6.25016Z" fill="#ED6D48" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Cancel confirmation modal (same style as logout modal) */}
            {cancelModalRequestId && (
                <>
                    <div className="modal-overlay" onClick={handleCancelClose} aria-hidden="true" />
                    <div className="logout-modal" role="dialog" aria-modal="true" aria-labelledby="cancel-modal-title">
                        <h3 id="cancel-modal-title" style={{ margin: '0 0 15px 0', fontSize: '20px', fontWeight: '600', color: '#fff' }}>
                            {stringsoflanguages.cancelRequest}
                        </h3>
                        <p style={{ margin: '0 0 25px 0', fontSize: '16px', color: '#fff', lineHeight: '1.5' }}>
                            {stringsoflanguages.areYouSureYouWantToCancelTheFeedRequest}
                        </p>
                        <div className="btn-sec">
                            <button type="button" className="cancel-btn custom-btn" onClick={handleCancelClose}>
                                {stringsoflanguages.no}
                            </button>
                            <button type="button" className="save-btn custom-btn" onClick={handleCancelConfirm}>
                                {stringsoflanguages.yes}
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}